import { useCallback, useEffect, useRef } from 'react';

/**
 * Returns a function that checks if the component is currently mounted.  Useful
 * if you want to avoid setting state on unmounted components, which is often
 * mistakenly done in asynchronous callbacks
 *
 * @see https://usehooks-ts.com/react-hook/use-is-mounted
 */
export function useCheckIsMounted() {
  var isMounted = useRef(false);
  useEffect(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  return useCallback(function () {
    return isMounted.current;
  }, []);
}